/**
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 */

const ignoredGenericEvents: string[] = ["scroll", "mousemove"];

const ignoredMediaEvents: string[] = [
  "loadedmetadata",
  "canplay",
  "canplaythrough",
  "timeupdate",
  "progress",
  "play",
  "playing",
  "pause",
];

(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  ...ignoredGenericEvents,
  ...ignoredMediaEvents,
];

(window as any).__Zone_disable_requestAnimationFrame = true;
(window as any).__Zone_disable_requestVideoFrameCallback = true;
